export default {
    common: {
        title: 'Innehålls AI',
        socialPlanner: 'Social planerare',
        blog: 'Blogg',
        funnel: 'Tratt',
        website: 'Hemsida',
        mediaLibrary: 'Mediabibliotek',
        email: 'E-post',
        words: 'Ord',
        variations: 'Varianter',
        thisIsPaidService: 'Denna funktion är en betaltjänst och kommer att medföra avgifter baserat på din användning',
        all: 'Todos',
    },
};
